import { PropsWithChildren } from 'react';
import { FallbackComponentProps } from '../../interfaces/BugsnagInterface';
import { ErrorBoundary } from './BugSnagUtilities';

// Type-safe interface for FallbackComponent function
type FallbackComponentFunction = (
  props: FallbackComponentProps
) => React.ReactElement;

export interface BugsnagErrorBoundaryProps extends PropsWithChildren {
  //Fallback component to be rendered when an error occurs
  FallbackComponent: FallbackComponentFunction;
}

export const BugsnagErrorBoundary = ({
  children,
  FallbackComponent,
}: BugsnagErrorBoundaryProps) => {
  if (ErrorBoundary) {
    return (
      <ErrorBoundary
        onError={event => (event.unhandled = true)}
        FallbackComponent={props =>
          (FallbackComponent as FallbackComponentFunction)(props)
        }
      >
        {children}
      </ErrorBoundary>
    );
  }
  return <>{children}</>;
};
